// extracted by mini-css-extract-plugin
export var layoutContainer = "_d-0";
export var layoutContainerNoRounding = "_d-6";
export var layoutContainerOpen = "_d-5";
export var layoutContainerResizing = "_d-1";
export var mainContent = "_d-2";
export var resizeDivider = "_d-3";
export var slidePanel = "_d-4";